import React from "react";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";
import { withStyles } from "@material-ui/core/styles";
import Theme from "../../App/Theme";

// const drawerWidth = 500;

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        height: 430,
        zIndex: 1,
        overflow: "hidden",
        position: "relative",
        display: "flex",
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    // drawerPaper: {
    //     position: 'relative',
    //     width: drawerWidth,
    // },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        minWidth: 0, // So the Typography noWrap works
    },
    toolbar: theme.mixins.toolbar,
});

class TAppSideBar extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        open: PropTypes.bool,
        classes: PropTypes.object,
        width: PropTypes.number,
    };

    static defaultProps = {
        open: true,
        width: 255,
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        // width was 255, but increasing due to DM.

        return (
            <Drawer
                variant="persistent"
                open={this.props.open}
                style={{ zIndex: Theme.zIndex.drawer, width: "300px", border: "3px solid #CCCCCC" }}
            >
                <div className={this.props.classes.toolbar} />

                <div style={{ height: "100%", width: this.props.width, ...Theme.sideBar, overflowY: "auto" }}>
                    {this.props.children ? this.props.children : <div>No children given</div>}
                </div>
            </Drawer>
        );
    }
}

export default withStyles(styles)(TAppSideBar);
